import { gql } from '@/utilities/gql';
import type { VariablesOf } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';
import type { QueryFunctionContext } from '@tanstack/react-query';

export function getQueryKey(
  canonicalUrl: string,
  names?: Readonly<string[]>
): [string, string, Readonly<string[]> | undefined] {
  return ['COMPANY_STATEMENTS', canonicalUrl || '', names || []];
}

const QUERY = gql(`
  query getCompanyStatements($canonicalURL: String!, $names: [String!]) {
    Company(canonicalURL: $canonicalURL) {
      statements(names: $names) {
        name
        value
        severity
        description {
          description
        }
      }
    }
  }
`);

type Args = VariablesOf<typeof QUERY>;

export const queryFn = async ({
  queryKey: [_keyof, canonicalURL, names],
}: QueryFunctionContext<[string, Args['canonicalURL'], Args['names']]>) => {
  const response = await gqlClient.request(QUERY, { canonicalURL, names });

  if ('Company' in response) {
    return response.Company;
  }
};
